<template>
  <div>
      <el-button type="primary" icon="el-icon-edit" @click="dialogFormVisible = true">新建</el-button>
      <el-table
        :data="tableData"
        border
        :cell-style="{textAlign: 'center'}"
        :header-cell-style="{textAlign: 'center',background: 'rgb(232,232,232)',color: 'black', fontWeight: 500}"
        style="width: 100%">
        <el-table-column
          prop="type"
          label="名称">
        </el-table-column>
        <el-table-column
          label="模型路径">
          <template slot-scope="scope">
            <span>{{ scope.row.url }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="coor"
          label="中心点坐标">
        </el-table-column>
        <el-table-column
          prop="heading"
          label="指向">
        </el-table-column>
        <el-table-column
          prop="pitch"
          label="视角">
        </el-table-column>
        <el-table-column
          prop="rotateZ"
          label="旋转角度">
        </el-table-column>
        <el-table-column
          prop="scale"
          label="视角高度">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="margin-right: 20%" @click="edit(scope.row)" class="tableBtn">编辑</span>
            <span class="tableBtn" style="color: red" @click="remove(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>


    <!-- 弹窗 -->
    <div class="formBox">
      <el-dialog title="模型信息" :visible.sync="dialogFormVisible" width="30%">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="名称" :label-width="formLabelWidth" prop="type">
            <el-input v-model="form.type" auto-complete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="中心点经度" :label-width="formLabelWidth" size="small" prop="heading">
            <el-input v-model="form.coor[0]" auto-complete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="中心点纬度" :label-width="formLabelWidth" size="small" prop="heading">
            <el-input v-model="form.coor[1]" auto-complete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="指向" :label-width="formLabelWidth" size="small" prop="heading">
            <el-input v-model="form.heading" auto-complete="off" size="small" type="number"></el-input>
          </el-form-item>
          <el-form-item label="视角" :label-width="formLabelWidth" prop="pitch">
            <el-input v-model="form.pitch" auto-complete="off" size="small" type="number"></el-input>
          </el-form-item>
          <el-form-item label="旋转角度" :label-width="formLabelWidth" prop="rotateZ">
            <el-input v-model="form.rotateZ" auto-complete="off" size="small" type="number"></el-input>
          </el-form-item>
          <el-form-item label="视角高度" :label-width="formLabelWidth" prop="scale">
            <el-input v-model="form.scale" auto-complete="off" size="small" type="number"></el-input>
          </el-form-item>
          <el-form-item label="模型路径" :label-width="formLabelWidth" prop="url">
            <el-input v-model="form.url" auto-complete="off" size="small"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin:auto">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="sureBtn('form')" size="small">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getModelList,removeModel, addModel, editModel } from '@/api/processManager'
export default {
  name: 'processModelManagerment',
  filters: {
    Calculator(val) {
      return val.split('/')[3]
    }
  },
   data() {
    return {
      tableData: [],
      // 弹出框表格得数据
      dialogFormVisible: false,
      form: {
        type: '',
        coor: [],
        coor1: [],
        heading: '',
        scale: '',
        pitch: '',
        rotateZ: '',
        url: []
      },
      form2: { //这个form2表单是用来让弹窗关闭的时候把弹窗里面的数据置空
        type: '',
        coor: [],
        coor1: [],
        heading: '',
        scale: '',
        pitch: '',
        rotateZ: '',
        url: []
      },
      optionList: [], // 下拉框的数据
      isEdit: false, // 判断是新增还是编辑，默认是false（新增）
      id: '', // 存放车辆信息的id，编辑的时候要用
      formLabelWidth: '120px',
      rules: {
        type: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        coor: [
          { required: true, message: '请输入经纬度', trigger: 'blur' }
        ],
        coor1: [
          { required: true, message: '请输入经纬度', trigger: 'blur' }
        ],
        heading: [
          { required: true, message: '请输入水平位移值', trigger: 'blur' }
        ],
        pitch: [
          { required: true, message: '请输入垂直位移值', trigger: 'blur' }
        ],
        rotateZ: [
          { required: true, message: '请输入旋转角度', trigger: 'blur' }
        ]
      },
      fileList: []
    }
  },
  watch: {
    // 监听弹窗的开关状态
    dialogFormVisible(val) {
      let that = this
      if(val === false) {
        // 关闭弹窗时取消表单的验证信息
        that.$refs['form'].resetFields()
        this.form = {...this.form2}
        that.isEdit = false
        that.fileList = []
      }
    }
  },
  methods: {
    // 弹窗的确定按钮
    sureBtn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // isAdd为false为新增
          if(this.isEdit === false) {
            addModel({...this.form}).then(res => {
              this.$message.success('添加成功')
              this.dialogFormVisible = false
              this.getList(this.curPage)
            })
            // isAdd为true为编辑
          }else{
            let obj = {
              url: this.form.url,
              id: this.form.id,
              coor: this.form.coor,
              coor1: this.form.coor1,
              heading: this.form.heading,
              pitch: this.form.pitch,
              scale: this.form.scale,
              type: this.form.type,
              rotateZ: this.form.rotateZ
            }
            editModel({
              ...obj
            }).then(res => {
              this.$message.success('修改成功')
              this.dialogFormVisible = false
              this.getList(this.curPage)
            })
          }
        } else {
          return false;
        }
      });
    },
    // 上传组件的事件
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    // 上传成功的回调
    uploadSuccess(file) {
      // console.log(file)
      // this.fileList.push(file.msg)
      this.form.url = file.data
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 获取列表
    getList() {
      getModelList().then(res => {
        this.tableData = res.body.data
      })
    },
    // 删除
    remove(val) {
      this.$confirm('此操作将删除该条数据, 包括里面的文件, 此后您将不能再看见地图里的模型 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        removeModel(val).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getList()
        })
      }).catch(() => {
        return
      })
    },
    // 编辑按钮
    edit(val) {
      this.dialogFormVisible = true
      this.isEdit = true
      let str = val.coor
      let arr = str.split(',')
      let obj = {...val}
      obj.coor = arr
      if(val.coor1 && val.coor1.length !== 0) {
        obj.coor1 = val.coor1.split(',')
      }
      obj.url = []
      obj.url.push(val.url)
      this.form = obj
      // console.log(this.form)
      this.fileList.push({url: val.url, name: val.url})
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scope>
.innerBox {
  margin: auto;
  width: 100%;
  /* height: 870px; */
  height: 100%;
  padding: 15px;
  border: 1px solid rgb(232,232,232);
  background-color: white;
}
.formBox /deep/ .el-form-item {
    margin-bottom: 10px
  }
.formBox /deep/ .el-form-item__error {
  padding-top: 2px
}
.tableBtn {
  cursor: pointer;
}
</style>
